/**
 * dataLayer push helper scoped to the Program flow in ui-kit-site.
 *
 * This library is shared across central-hub, staff-hub and set-edu.
 * Only central-hub currently loads GTM (see its `index.html`), so the
 * push is a no-op in the other apps — `window.dataLayer` is initialised
 * lazily here and the pushed entries just accumulate in an unread
 * in-memory array.
 *
 * Kept here (rather than in central-hub) so the program enrollment
 * modals can fire events inline from their mutation onCompleted
 * handlers without prop drilling.
 *
 * Note: we intentionally avoid `declare global { interface Window }`
 * here. Central-hub owns the global `Window.dataLayer` type augmentation
 * (see `apps/central-hub/src/lib/analytics.ts`); adding a second one
 * from the library triggers TS2717 when the two interfaces diverge.
 */

interface DataLayerEntry {
  event: string;
  [key: string]: unknown;
}

type WindowWithDataLayer = Window & { dataLayer?: DataLayerEntry[] };

export const pushDataLayerEvent = (entry: DataLayerEntry) => {
  if (typeof window === 'undefined') return;
  const w = window as WindowWithDataLayer;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(entry);
};
